module.exports = __webpack_public_path__ + "assets/images/down-icon.00ef7dbf36a670360c478f62cba4b5c3.svg";